import { MarketplaceController } from "PFApp/marketplace";
import { MarketplacePage } from "PFApp/marketplace/constants/marketplace_page";
import NotFoundRoute from "PFApp/routes/not_found_route";
import {
  EnsureLoggedInAndRegistered,
  EnsureMarketplacePermission,
  WithLayout
} from "PFApp/routes/route_helpers";
import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

export const MarketplaceRoutes = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <EnsureLoggedInAndRegistered>
      <EnsureMarketplacePermission>
        <WithLayout>
          <Switch>
            <Route exact path={path}>
              <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/dashboard`}>
              <MarketplaceController page={MarketplacePage.Dashboard} />
            </Route>

            <Route exact path={`${path}/work_opportunities`}>
              <Redirect to={`${path}/work_opportunities/matching_roles`} />
            </Route>
            <Route exact path={`${path}/work_opportunities/:tab`}>
              <MarketplaceController page={MarketplacePage.WorkOpportunities} />
            </Route>

            <Route path="*">
              <NotFoundRoute />
            </Route>
          </Switch>
        </WithLayout>
      </EnsureMarketplacePermission>
    </EnsureLoggedInAndRegistered>
  );
};
